import { SelectRegistrationTranslator } from 'src/translators'
import {
  RoomSelectRegistrationResponse,
  RoomSelectRegistrationsResponse,
  RoomSelectRegistrationEntity,
} from 'src/types'

export const RoomSelectRegistrationTranslator = {
  toEntity: (response: RoomSelectRegistrationResponse): RoomSelectRegistrationEntity => {
    return {
      id: `${response.id}`,
      selects: response.selects.map(r => SelectRegistrationTranslator.toEntity(r)),
    }
  },

  toEntities: (response: RoomSelectRegistrationsResponse): RoomSelectRegistrationEntity[] => {
    return response.rooms.map(r => RoomSelectRegistrationTranslator.toEntity(r))
  },
} as const
